import React from 'react';
import './FsaPlusTitle.css';


const FsaPlusTitle = () => {  
    return (
      <div className='fsaPlus-title-container'>
        <div className='fsaPlus-title'>
          <div className='fsaPlus-left-box' />
          <div className='fsaPlus-right-box' />
          <h1>FSA</h1>
          <h2>+</h2>
        </div>
      </div>
  );
}

export default FsaPlusTitle;